<template>
  <div class="app-main-inner">
    <div class="app-main-top">
      <h1>{{ $t("lang.classRoom10") }}</h1>
      <div class="select-box">
        <b></b>
        <el-select v-model="courseTypeSelected" placeholder="Please select">
          <el-option
            v-for="item in courseType"
            :key="item.id"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="select-box margin-left-30">
        <b></b>
        <el-select v-model="tabsValue" placeholder="Please select">
          <el-option
            v-for="item in tabs"
            :key="item.id"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="search-btn" @click="handleSearch">{{ $t("lang.classRoom11") }}</div>
      <div class="tip">{{ $t("lang.classRoom12") }}</div>
    </div>
    <div class="app-main-middle">
      <div class="data-search-result">
        <ul v-if="lessonList.length>0">
          <li v-for="item in lessonList" :key="item.id" >
            <div class="margin-bottom-20">
              <span v-if="item.courseType===3||(item.courseType===0&&item.trial)" class="class-auditions">{{ $t("lang.homePage34") }}</span>
              <span v-if="item.courseType===2" class="class-1Vn">{{ $t("lang.homePage5") }}</span>
              <span v-if="item.courseType===1" class="class-open">{{ $t("lang.homePage4") }}</span>
              <span v-if="item.courseType===0&&!item.trial" class="class-private">{{ $t("lang.homePage3") }}</span>
              <span>{{item.courseName}}</span>
              <span v-if="item.lessonName">{{item.lessonName}}</span>
              <span v-if="item.stuSimpInfo.length>0 && item.stuSimpInfo[0].childEnName">{{language === 'cn' ? item.stuSimpInfo[0].childCnName : item.stuSimpInfo[0].childEnName}}</span>
              <span v-if="item.stuSimpInfo.length>0 && item.stuSimpInfo[0].age">{{ $t("lang.userPage56") }}:{{item.stuSimpInfo[0].age}}</span>
              <span class="border-none" v-if="item.lessonStatus===0">{{ $t("lang.classRoom13") }}</span>
              <span class="border-none" v-else-if="item.lessonStatus===1">{{ $t("lang.classRoom14") }}</span>
              <span class="border-none" v-else-if="item.lessonStatus===2">{{ $t("lang.classRoom15") }}</span>
              <span class="border-none" v-else-if="item.lessonStatus===3">{{ $t("lang.classRoom16") }}</span>
              <span class="border-none" v-else-if="item.lessonStatus===4">{{ $t("lang.classRoom17") }}</span>
              <span class="border-none" v-else-if="item.lessonStatus===5">{{ $t("lang.classRoom18") }}</span>
              <span class="border-none" v-else-if="item.lessonStatus===6">{{ $t("lang.classRoom19") }}</span>
            </div>
            <div class="classRoom-operating">
              <span class="classRoom-time border-none">{{$utils.formatLocalTimeYYYYMMDDHHmmss(item.localStartTime,timezone)}}</span>
              <span class="classRoom-integral border-none" v-if="item.courseType!==1"><i></i>x{{item.orangeGiftAmount}}</span>
              <span class="classRoom-fraction border-none" v-if="item.studentReviews && item.courseType!==1"><i></i>x{{item.studentReviews.star}}</span>
              <!-- <span class="classRoom-fee border-none">{{ $t("lang.classRoom37") }}$12.00</span> -->
              <span class="classRoom-fee border-none" v-if="item.salary">{{ $t("lang.classRoom37") }}{{currencyType === 'CNY' ? '&yen;' : '$'}}{{item.salary ? item.salary : '12.00'}}</span>
              <a v-bind:href="item.roomUrl" target="_blank" rel="noopener" class="btn fr" v-if="item.lessonStatus===2 || item.lessonStatus===6">{{ $t("lang.homePage8") }}</a>
              <span v-else-if="item.lessonStatus===4 || item.lessonStatus===5" class="border-none">
                <a class="btn fr btn-disabled">{{ $t("lang.classRoom20") }}</a>
              </span>
              <span v-else class="border-none">
                <a v-bind:href="item.roomUrl" class="btn fr" target="_blank" rel="noopener">{{ $t("lang.homePage8") }}</a>
                <a @click="gonext(item)" class="btn fr">{{ $t("lang.classRoom21") }}</a>
              </span>
              <a class="btn fr" @click="openCommentDialog(item.id)" v-if="item.teacherReviews===null && item.courseType!==1 && item.courseType!==2 && item.lessonStatus!==0 && item.lessonStatus!==1">{{ $t("lang.classRoom25") }}</a>
              <a class="btn fr" v-if="item.stuSimpInfo.length>0" @click="openStudentDialog(item.stuSimpInfo)">{{ $t("lang.classRoom22") }}</a>
            </div>
            <div class="teacher-remark" v-if="item.remark">
              <span>Bingotalk</span>
              <span class="border-none">{{$utils.formatLocalTimeYYYYMMDD(item.localStartTime,timezone)}}</span>
              <div class="remark-comtent">
                {{item.remark ? item.remark : ''}}
              </div>
            </div>
          </li>
          <div class="pagination">
            <el-pagination
              layout="prev, pager, next"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :total="totalElements"
              :page-size="pageSize"
              :current-page="pageNumber"
              v-if="totalPages>1"
              >
            </el-pagination>
          </div>
        </ul>
        <div class="no-data" v-else>{{ $t("lang.classRoom23") }}</div>
      </div>
    </div>
    <div class="box dialog-box" v-bind:class="{ fade: isStudentFade}">
      <div class="box-inner">
        <div class="dialog-info dialog-student-info">
          <div class="title">{{ $t("lang.classRoom22") }}
            <div class="dialog-close-btn" @click="closeStudentDialog"></div>
          </div>
          <div class="student-info-box">
            <img class="student-img" :src="stuSimpInfo.avatar">
            <div class="student-info-text">
              <p>{{ $t("lang.userPage1") }}：{{ this.language === 'cn' ? stuSimpInfo.childCnName : stuSimpInfo.childEnName }}</p>
              <p>{{ $t("lang.userPage56") }}：{{stuSimpInfo.age}}</p>
              <p>{{ $t("lang.userPage4") }}：
                <template v-if="stuSimpInfo.childGender==='MALE'">
                  {{ $t("lang.userPage5") }}
                </template>
                <template v-else>
                  {{ $t("lang.userPage6") }}
                </template>
              </p>
            </div>
          </div>
          <div class="reviews-box">
            <h1>{{ $t("lang.classRoom26") }}</h1>
            <ul v-if="studentReviews.length>0">
              <li v-for="item in studentReviews" :key="item.id">
                <img class="teacher-img" :src="item.fUserAvarta">
                <div class="reviews-info">
                  <div class="reviews-fraction">
                    <div class="fraction-box">
                      <div class="fraction-no">
                        <div class="fraction" :style="'width:'+item.star/totleScore*100+'%'"></div>
                      </div>
                      <div class="fraction-status">
                        <span v-if="item.star===1">{{ $t("lang.classRoom28") }}</span>
                        <span v-if="item.star===2">{{ $t("lang.classRoom29") }}</span>
                        <span v-if="item.star===3">{{ $t("lang.classRoom30") }}</span>
                        <span v-if="item.star===4">{{ $t("lang.classRoom31") }}</span>
                        <span v-if="item.star===5">{{ $t("lang.classRoom32") }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="reviews-text">
                    {{item.content}}
                  </div>
                </div>
              </li>
            </ul>
            <div class="no-data" v-else>{{ $t("lang.classRoom27") }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box dialog-box" v-bind:class="{ fade: isCommentFade}">
      <div class="box-inner">
        <div class="dialog-info">
          <div class="title">{{ $t("lang.classRoom25") }}</div>
          <div class="form-group text-align-left">
            <label for="">{{ $t("lang.classRoom33") }}</label>
            <div class="form-group-fraction">
              <div class="fraction-box">
                <div class="fraction-no">
                  <div class="fraction" :style="'width:' + studentScoreWidth"></div>
                </div>
                <div class="fraction-status">
                  <span v-if="commentParam.star===1">{{ $t("lang.classRoom28") }}</span>
                  <span v-if="commentParam.star===2">{{ $t("lang.classRoom29") }}</span>
                  <span v-if="commentParam.star===3">{{ $t("lang.classRoom30") }}</span>
                  <span v-if="commentParam.star===4">{{ $t("lang.classRoom31") }}</span>
                  <span v-if="commentParam.star===5">{{ $t("lang.classRoom32") }}</span>
                </div>
                <ul class="">
                  <li @click="fraction(1,1)"></li>
                  <li @click="fraction(1,2)"></li>
                  <li @click="fraction(1,3)"></li>
                  <li @click="fraction(1,4)"></li>
                  <li @click="fraction(1,5)"></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="form-group text-align-left">
            <label for="">{{ $t("lang.classRoom34") }}</label>
            <div class="form-group-fraction">
              <div class="fraction-box">
                <div class="fraction-no">
                  <div class="fraction" :style="'width:' + platformScoreWidth"></div>
                </div>
                <div class="fraction-status">
                  <span v-if="commentParam.platformStar===1">{{ $t("lang.classRoom28") }}</span>
                  <span v-if="commentParam.platformStar===2">{{ $t("lang.classRoom29") }}</span>
                  <span v-if="commentParam.platformStar===3">{{ $t("lang.classRoom30") }}</span>
                  <span v-if="commentParam.platformStar===4">{{ $t("lang.classRoom31") }}</span>
                  <span v-if="commentParam.platformStar===5">{{ $t("lang.classRoom32") }}</span>
                </div>
                <ul class="">
                  <li @click="fraction(2,1)"></li>
                  <li @click="fraction(2,2)"></li>
                  <li @click="fraction(2,3)"></li>
                  <li @click="fraction(2,4)"></li>
                  <li @click="fraction(2,5)"></li>
                </ul>
              </div>
            </div>
          </div>
          <div class="form-group text-align-left">
            <label for="introduction">{{ $t("lang.classRoom25") }}</label>
            <div class="textarea-box">
              <textarea id="introduction" cols="30" rows="10" v-model.trim="commentParam.content" :placeholder="$t('lang.classRoom35')" maxlength="500" ></textarea>
              <div class="chat-count">{{commentParam.content.length}}/500</div>
            </div>
          </div>
          <div class="form-group">
            <a class="btn-cancel fl" @click="closeCommentDialog">{{ $t("lang.userPage64") }}</a>
            <a class="btn-ok fr" @click="updateComment">{{ $t("lang.loginPage15") }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "components/app-header/app-header";
import AppSilder from "components/app-silder/app-silder";
import {
  getClassRoomList,
  getStudentReviews,
  saveReviews,
  getWallet
} from "api/classRoom";
import store from '../../store';
import { mapGetters } from "vuex";
import { ERR_OK } from "api/config";
export default {
  data() {
    return {
      courseType: [],
      courseTypeSelected: "",
      tabs: [],
      tabsValue: "",
      lessonList: [],
      pageNumber: 1,
      pageSize: 5,
      totalPages: "",
      totalElements: "",
      isStudentFade: false,
      isCommentFade: false,
      commentParam: {
        type: 0,
        lessonId: "",
        star: 5,
        platformStar: 5,
        content: ""
      },
      totleScore: 5,
      studentScoreWidth: "100%",
      platformScoreWidth: "100%",
      stuSimpInfo: [],
      studentReviews: [],
      language: "",
      currencyType: ''
    };
  },
  computed: {
    ...mapGetters(["timezone"])
  },
  components: {
    AppHeader,
    AppSilder
  },
  created() {
    this._getClassRoomList();
    this.setLanguage();
    this.setCourseType();
    this.getWallet()
  },
  methods: {
    gonext(item) {
      this.$router.push({
        path: "/classroom/lessonInfo",
        query: {
          title: item.lessonName,
          lessonId: item.id,
          documentId: item.documentId,
          roomId: item.roomId,
          lessonModel: item.lessonModel
        }
      });
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNumber = val;
      this._getClassRoomList();
    },
    handleSearch() {
      this.pageNumber = 1;
      this._getClassRoomList();
    },
    _getClassRoomList() {
      let courseTypeParme = {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        courseType: this.courseTypeSelected,
        lessonStatus: this.tabsValue
      };
      getClassRoomList(courseTypeParme)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.lessonList = response.data.data.content;
              this.totalPages = response.data.data.totalPages;
              this.totalElements = response.data.data.totalElements;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    _getUserInfo() {
      this.$store
        .dispatch("GetUserInfo")
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.userinfo = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(() => {});
    },
    updateComment() {
      if (this.commentParam.content.length < 1) {
        this.commentParam.content = "学生课堂表现非常好";
      }
      saveReviews(this.commentParam)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === 200) {
              this._getClassRoomList();
              this._getUserInfo();
              this.$message.success(this.$t('lang.classRoom36'));
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
      this.closeCommentDialog();
    },
    fraction(type, score) {
      if (type === 1) {
        this.commentParam.star = score;
        this.studentScoreWidth = score / this.totleScore * 100 + "%";
      } else {
        this.commentParam.platformStar = score;
        this.platformScoreWidth = score / this.totleScore * 100 + "%";
      }
    },
    openStudentDialog(stuSimpInfo) {
      this.stuSimpInfo = stuSimpInfo[0];
      const params = {
        studentId: stuSimpInfo[0].id,
        pageNumber: 1,
        pageSize: 3
      };
      getStudentReviews(params)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === 200) {
              this.studentReviews = response.data.data.content;
              this.isStudentFade = true;
              document.body.setAttribute("class", "dialogfade");
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    getWallet() {
      console.log('getWallet')
      getWallet().then(response => {
        if (response.status !== 200) {
          this.$message.error(response.data.message);
        } else {
          if (+response.data.code === 200) {
            this.currencyType = response.data.data.currencyType || ''
          } else {
            this.$message.error(response.data.message);
          }
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    closeStudentDialog() {
      this.isStudentFade = false;
      document.body.removeAttribute("class", "dialogfade");
    },
    formatCommentParam() {
      this.commentParam = {
        type: 0,
        lessonId: "",
        star: 5,
        platformStar: 5,
        content: ""
      };
      this.studentScoreWidth = "100%";
      this.platformScoreWidth = "100%";
    },
    openCommentDialog(lessonId) {
      this.commentParam.lessonId = lessonId;
      this.isCommentFade = true;
      document.body.setAttribute("class", "dialogfade");
    },
    closeCommentDialog() {
      this.isCommentFade = false;
      this.formatCommentParam();
      document.body.removeAttribute("class", "dialogfade");
    },
    setCourseType() {
      this.courseType = [
        {
          value: "",
          label: this.$t("lang.classRoom24")
        },
        {
          value: 0,
          label: this.$t("lang.homePage3")
        },
        {
          value: 1,
          label: this.$t("lang.homePage4")
        },
        {
          value: 2,
          label: this.$t("lang.homePage5")
        },
        {
          value: 3,
          label: this.$t("lang.homePage34")
        }
      ]
      this.tabs = [
        {
          value: "",
          label: this.$t("lang.classRoom24")
        },
        {
          value: 0,
          label: this.$t("lang.classRoom13")
        },
        {
          value: 1,
          label: this.$t("lang.classRoom14")
        },
        {
          value: 2,
          label: this.$t("lang.classRoom15")
        },
        {
          value: 3,
          label: this.$t("lang.classRoom16")
        },
        {
          value: 4,
          label: this.$t("lang.classRoom17")
        },
        {
          value: 5,
          label: this.$t("lang.classRoom18")
        },
        {
          value: 6,
          label: this.$t("lang.classRoom19")
        }
      ]
    },
    setLanguage() {
      this.language = store.state.app.language;
    }
  },
  watch: {
    '$i18n.locale' () {
      this._getClassRoomList();
      this.setLanguage();
      this.setCourseType();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.app-main-inner {
  .app-main-top {
    height: auto;
    h1 {
      font-size: 20px;
      margin: 0px 10px;
    }
    .select-box {
      width: 200px;
    }
    .search-btn {
      display: inline-block;
      width: 95px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      background: rgba(255, 164, 56, 0.5);
      border: 1px solid #ffa438;
      border-radius: 20px;
      color: #fff;
      position: relative;
      top: -9px;
      margin-left: 30px;
      cursor: pointer;
    }
    .tip {
      font-size: 14px;
      color: #ffa438;
      height: 20px;
      line-height: 20px;
      margin-bottom: 20px;
      text-indent: 10px;
    }
  }
  .app-main-middle {
    padding: 20px;
  }
}
.data-search-tab {
  margin-bottom: 20px;
  ul {
    @include clearfix;
    li {
      display: inline-block;
      font-size: 16px;
      color: #333;
      cursor: pointer;
      float: left;
      margin-right: 40px;
    }
    li.active {
      color: $baseColor;
    }
  }
}
.data-search-result {
  ul {
    @include clearfix;
    li {
      padding: 20px;
      border: 1px solid #dedede;
      margin-bottom: 15px;
      border-radius: 4px;
      span {
        padding: 0px 15px 0px 10px;
        border-right: 1px solid #dedede;
      }
      .classRoom-time {
        color: #bebebe;
      }
      .classRoom-integral {
        i {
          display: inline-block;
          width: 20px;
          height: 22px;
          background: url(~assets/images/integral.png) center center no-repeat;
          background-size: cover;
          position: relative;
          top: 4px;
          margin-right: 5px;
        }
      }
      .classRoom-fraction {
        i {
          display: inline-block;
          width: 18px;
          height: 18px;
          background: url(~assets/images/icon-star.png) center center no-repeat;
          background-size: cover;
          position: relative;
          top: 3px;
          margin-right: 5px;
        }
      }
      .classRoom-people {
        cursor: pointer;
        color: $baseColor;
      }
      .classRoom-status {
        color: $tiffany;
      }
      .classRoom-operating {
        line-height: 36px;
        @include clearfix;
      }
      .btn {
        width: 120px;
        height: 36px;
        line-height: 30px;
        display: inline-block;
        margin-left: 20px;
      }
    }
  }

  .teacher-remark {
    margin-top: 16px;
    border-top: 1px solid #dedede;
    padding: 8px 0;
    color: #4e4e4e;
    .remark-comtent {
      margin: 10px 0;
      padding: 16px 8px;
      border: 1px dashed #dedede;
      border-radius: 6px;
    }
  }
}
.dialog-box {
  .dialog-info {
    width: 400px;
    margin: 0 auto;
    padding: 20px 50px;
    &.dialog-student-info {
      width: 600px;
    }
    .title {
      margin-bottom: 30px;
    }
  }
}
.fraction-box {
  width: 110px;
  height: 15px;
  position: relative;
  .fraction-no {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(~assets/images/fraction-no.png) no-repeat;
    background-size: cover;
    .fraction {
      position: absolute;
      width: 0%;
      height: 100%;
      background: url(~assets/images/fraction.png) no-repeat;
      background-size: cover;
      transition: 0.4s all;
    }
  }
  ul {
    position: absolute;
    z-index: 9;
    width: 120px;
    height: 15px;
    li {
      display: inline-block;
      width: 15px;
      height: 15px;
      float: left;
      margin-right: 9px;
    }
  }
  .fraction-status {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    line-height: 15px;
    transform: translateX(110%);
  }
}
.student-info-box {
  position: relative;
  padding-left: 110px;
  .student-img {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    position: absolute;
    top: 0px;
    left: 0px;
    border: 1px solid rgba(255, 164, 56, 0.5);
  }
  .student-info-text {
    p {
      line-height: 30px;
      margin: 0;
      text-align: left;
    }
  }
}
.reviews-box {
  text-align: left;
  margin: 30px 0px;
  h1 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  ul {
    li {
      position: relative;
      padding-left: 80px;
      margin-bottom: 10px;
      .teacher-img {
        display: block;
        width: 60px;
        height: 60px;
        position: absolute;
        left: 0;
        top: 0;
      }
      .reviews-info {
        padding: 10px;
        border: 1px solid rgba(255, 164, 56, 0.5);
        border-radius: 10px;
        color: #333;
        min-height: 43px;
        .reviews-text{
          word-break: break-all;
        }
        .reviews-fraction {
          margin-bottom: 10px;
        }
      }
    }
  }
}
.form-group {
  margin-bottom: 20px;
  label {
    width: 100px;
    float: left;
    height: 36px;
    line-height: 36px;
    color: #333;
    font-size: 14px;
  }
  input {
    width: 260px;
    float: right;
    height: 36px;
    background-color: #f5f5f5;
    border: 0;
    border-radius: 20px;
    padding: 0px 20px;
    outline: none;
    color: #bebebe;
  }
  .form-group-fraction {
    width: 260px;
    float: right;
    height: 36px;
    .fraction-box {
      margin-top: 10px;
    }
  }
  .textarea-box {
    width: 260px;
    float: right;
    background-color: #f5f5f5;
    border-radius: 20px;
    padding: 20px;
    height: 140px;
    position: relative;
    textarea {
      resize: none;
      width: 100%;
      height: 100%;
      background-color: #f5f5f5;
      border: 0;
      outline: none;
      color: #bebebe;
    }
    .chat-count {
      position: absolute;
      right: 10px;
      bottom: 10px;
      color: #ffa438;
    }
  }
  ::-webkit-input-placeholder {
    color: #bebebe;
  }
  .select-box {
    width: 300px;
  }
  .el-form-item {
    width: 260px;
  }
}
.btn-cancel {
  display: inline-block;
  padding: 7px 50px;
  color: $white;
  text-align: center;
  cursor: pointer;
  border-radius: 20px;
  background: #ccc;
  box-shadow: 2px 3px 0 0 #b1b1b1;
  font-size: 15px;
  border: 1px solid #ccc;
  &:hover {
    background-color: $white;
    color: #ccc;
  }
}
.btn-ok {
  display: inline-block;
  padding: 7px 50px;
  color: $white;
  text-align: center;
  cursor: pointer;
  border-radius: 20px;
  background: $baseColor;
  box-shadow: 2px 3px 0 0 #ca730c;
  font-size: 15px;
  border: 1px solid $baseColor;
  &:hover {
    background-color: $white;
    color: $baseColor;
  }
}
.pagination {
  background: #fff;
  text-align: center;
  .el-pagination {
    display: inline-block;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/classroom/classroom.vue